import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { SerializedError } from "@reduxjs/toolkit";

/**
 * Error-classification helper — the single source of truth for "is this
 * failure worth destroying the session over?".
 *
 * Transient failures (network drop, timeout, 408/425/429/5xx — typically a
 * backend redeploy or a flaky connection) must NEVER log the user out:
 * they resolve on their own within seconds. Only definitive identity
 * failures (401 with a known auth error code) justify a sign-out.
 */
export const isTransientError = (
  error: FetchBaseQueryError | SerializedError | undefined
): boolean => {
  if (!error || !("status" in error)) return false;
  const { status } = error;
  if (status === "FETCH_ERROR" || status === "TIMEOUT_ERROR" || status === "PARSING_ERROR") {
    return true;
  }
  return (
    typeof status === "number" &&
    (status >= 500 || status === 408 || status === 425 || status === 429)
  );
};
